import React from 'react'
import "../App.css"

const Navbar = () => {
    return (
        <div className="navbar">
            <h1>World's  Disaster  Tracker</h1>   
        </div>
    )
}

export default Navbar
